import React, { useContext } from 'react';
import { RowSelectionAction } from '@europrocurement/flexy-datatable';
import {
    DossierActionContext,
    useDossierTable as useDefaultDossierTable,
    useDossierFilters,
    useDossierPreFilters,
} from '@europrocurement/l2d-modules';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import ActionMenu from '../views/liste/ActionMenu/ActionMenu';

const useDossierTable = () => {
    const { columns } = useDefaultDossierTable({ application: 'FRONT' });
    const { triggerAction } = useContext(DossierActionContext);
    const { frontDossierFilter } = useDossierFilters();
    const { frontPreFilters } = useDossierPreFilters();

    columns.push({
        label: 'Actions',
        displayLabel: false,
        render: (dossier) => <ActionMenu dossier={dossier} />,
        isDisplayed: true,
        sortable: false,
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    });

    const rowActions: RowSelectionAction[] = [
        {
            icon: 'fa-folders',
            label: 'Déplacer dans un groupe',
            onClick: (items: Array<DossierOpenSearch>) => triggerAction('manageGroups', items),
        },
    ];

    return { columns, filters: frontDossierFilter, preFilters: frontPreFilters, rowActions };
};

export default useDossierTable;
